var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{attrs:{"placeholder":_vm.inputPlaceholder,"autocomplete":"none"},domProps:{"value":_vm.val},on:{"keyup":function (e) { return _vm.onChange(e); }}})}
var staticRenderFns = []

export { render, staticRenderFns }